import { rect } from '@geom';
import type { NID } from '@graph';

export class TitleEditorState {
  isVisible = $state(false);
  node: NID | undefined = undefined;
  title = '';
  change = $state(0);
  editorBounds = $state(rect(0, 0, 100, 100));
}
